import { Row } from '@cvent/carina/components/Row';
import { Col } from '@cvent/carina/components/Col';
import { Button as CButton } from '@cvent/carina/components/Button';
import React from 'react';
import styles from '../Reviews.module.scss';

interface FooterProps {
    setIsOpen: (isOpen: boolean) => void;
}

const Footer: React.FC<FooterProps> = ({ setIsOpen }) => (
   
        <Row justifyContent='flex-end'>
            <Col width='content'>
            <div className={styles.viewAll__footer}>
                <CButton appearance='filled' text='Done' onClick={() => setIsOpen(false)} />
            </div>
            </Col>
        </Row>
   
);

export default Footer;
